import {useLayoutStore} from '~/store/layout'

export default defineNuxtRouteMiddleware((to) => {
    nextTick(() => {
        useLayoutStore().setCurrentModule(to.meta?.module || 'dashboard')
    })
})